import api from './api';
import types from './mutation-types';
import _ from 'lodash';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPopupInit_({ commit }) {
		commit(types.POPUP_INIT);
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setPopupSearchParam_({ commit }, { key, value }) {
		commit(types.POPUP_SEARCH_PARAM, { key, value });
	},
	setSelectedRow_({ commit }, { key, value }) {
		commit(types.SELECTED_ROW, { key, value });
	},
	setPopupPagingInfo_({ commit }, { key, value }) {
		commit(types.POPUP_PAGING_INFO, { key, value });
	},
	postSearchSelectList_({ commit }) {
		return api
			.postSearchSelectList()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'companySaleList',
						value: data.body.SRCH_MM_04 || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},

	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getList({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				if(resultList){
					resultList.forEach(carSaleObj => {
						if(carSaleObj.wrntStrtDdManual && carSaleObj.wrntStrtDdManual == '1'){
							carSaleObj.wrntStrtDdManualFlag = true; 
						}else{
							carSaleObj.wrntStrtDdManualFlag = false;
						}
					});
				}
				commit(types.DEFAULT_ASSIGN, { key: 'mainResultList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getPopupList_({commit, state}) {
		try {
			const { popupSearchParams } = state;
			const data = await api.getPopupList({ popupSearchParams });
			if (data.header.code === 0) {
				const { result} = data.body;
				if(result){
					if(result.wrntStrtDdManual && result.wrntStrtDdManual == '1'){
						result.wrntStrtDdManualFlag = true; 
					}else{
						result.wrntStrtDdManualFlag = false;
					}
				}
				result && commit(types.DEFAULT_ASSIGN, { key: 'selectedRow', value: result });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	
	async saveData_({ state }, data) {
		try {
			console.log('*********data: ', data );
			if(data.get('wrntStrtDdManualFlag')){
				data.set('wrntStrtDdManual', '1');
			}else{
				data.set('wrntStrtDdManual', '0');
			}
			const response = await api.saveData(data);
			return response;
		} catch (error) {
			throw error?.header || error;
		}
	},
	
	// 출력시 출력상태 업데이트
	async updateWrntStrtDd_({ state }) {
		try {
			const { pmcId, ipnNos, wrntStrtDd } = state.selectedRow;
			const response = await api.updateWrntStrtDd({ pmcId, ipnNos, wrntStrtDd });
			return response;
		} catch (error) {
			throw error?.header || error;
		}
	}
};
